// extracted by mini-css-extract-plugin
module.exports = {"key__benefits__wrapper":"key-benefits_key__benefits__wrapper__20oWY","key__benefits__item":"key-benefits_key__benefits__item__29fZi"};